(() => {
    angular
      .module('finance')
      .controller(
        'finance.views.debugTools.syncCurlecTransactionsSettlementModal',
        SyncCurlecTransactionsSettlementModalController
      );
  
      SyncCurlecTransactionsSettlementModalController.$inject = [
      '$uibModalInstance',
      'abp.services.finance.debugTools',
    ];
  
    function SyncCurlecTransactionsSettlementModalController(
      $uibModalInstance, 
      debugToolsSvc
    ) {
      const vm = this;
      
      vm.saving = 0;
  
      vm.syncCurlecSettlements = syncCurlecSettlements;
      vm.cancel = cancel;
  
      function syncCurlecSettlements() {
        vm.saving += 1;
        debugToolsSvc
          .syncCurlecTransactionsSettlement({
            settlementDate: vm.settlementDate
          })
          .success(() => {
            abp.notify.success(App.localize('SuccessfullyScheduled'));
          })
          .finally(() => {
            $uibModalInstance.close();
          });
      }
  
      function cancel() {
        $uibModalInstance.dismiss();
      }
    }
  })();